// extracted by mini-css-extract-plugin
export default {"container":"yW-z","title":"zW-z","link":"AW-z"};